import { createContext } from 'react'
import { User } from 'modules/user/types'
import { Token } from '../types'

export interface AuthContextProvider {
  user?: User
  tokens?: Token
  login: () => void
  logout: () => void
  signUp: () => void
  isAuthComplete: boolean
}

export const AuthContext = createContext<AuthContextProvider>({
  login: () => {},
  logout: () => {},
  signUp: () => {},
  isAuthComplete: false
})
